import { FormLabel, Stack } from '@chakra-ui/react';
import { getI18n, useTranslation } from 'react-i18next';
import Select from 'react-select';

import { PartialStateCode } from '../../api/types';

export function MultiSelectDropDown(
  status: Array<string | number>,
  setStatus: (value: Array<string | number>) => void,
  translationKey: string,
  codes: PartialStateCode<string>,
  allStatusSelected?: boolean,
  title?: String,
  isPriority?: boolean,
) {
  const { t } = useTranslation();

  const styles = {
    clearIndicator: (styles: any) => ({
      ...styles,
      color: 'red',
    }),
    placeholder: (styles: any) => ({
      ...styles,
      color: 'black',
    }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      color: 'black',
    }),
    menuList: (styles: any) => ({
      ...styles,
      paddingLeft: '10px',
      paddingRight: '10px',
      backgroundColor: 'gray',
      borderRadius: '4px',
      borderColor: 'black',
      border: '2px',
    }),
    control: (styles: any) => ({
      ...styles,
      backgroundColor: 'white',
      borderColor: 'gray.200',
      borderRadius: '6px',
      minHeight: '40px',
    }),
    option: (styles: any, { isFocused }: any) => {
      return {
        backgroundColor: isFocused ? '#6094ec' : 'gray',
        color: 'white',
        borderRadius: '4px',
      };
    },
  };

  const selectedStatus = status.map((key) => {
    // A selected filter value may reference a status code that is absent from the
    // current codes map (e.g. a persisted filter, or codes not yet loaded). In
    // that case codes[key] is undefined -- fall back to the raw code instead of
    // requesting the broken "status.undefined.label" key from i18next.
    const statusName = codes[key];
    return {
      value: parseInt(String(key), 10),
      label: isPriority ? statusName : statusName ? getI18n().t(`${translationKey}:status.${statusName}.label`) : String(key),
    };
  });

  const dropdownOptions = Object.entries(codes)
    .map(([value, label]) => ({
      value: parseInt(value, 10),
      label: isPriority ? label : getI18n().t(`${translationKey}` + ':status.' + `${label}` + '.label'),
    }))
    .sort((a, b) => b.value - a.value);

  return (
    <Stack direction={'column'} width={'300px'} mt={5}>
      <FormLabel size="lg" pl="1" mb={0}>
        {title}
      </FormLabel>
      <Select
        isMulti
        placeholder={t('components:table.filters.select')}
        styles={styles}
        isClearable={true}
        aria-label={'multiselect-filter'}
        value={selectedStatus}
        options={dropdownOptions}
        // Fixes the overlapping problem of the dropdown
        menuPosition={'fixed'}
        onChange={(selectedOptions) => {
          // Extract an array of values from the selected options
          const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value.toString()) : [];

          setStatus(selectedValues);

          // Clear the status if allStatusSelected is true
          if (allStatusSelected) {
            setStatus([]);
          }
        }}
      />
    </Stack>
  );
}
